import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/shared/services/data/data.service';

@Component({
  selector: 'app-confirm-email-licence',
  templateUrl: './confirm-email-licence.component.html',
  styleUrls: ['./confirm-email-licence.component.scss']
})
export class ConfirmEmailLicenceComponent implements OnInit {

  constructor(
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.dataService.confirmEmailLicence.next(false);
    }, 5000);
  }

}
